import { philosophy } from "@/mocks/site-data";
import Reveal from "@/components/feature/Reveal";

export default function Philosophy() {
  return (
    <section className="bg-background-100/80 py-20 md:py-28">
      <div className="mx-auto max-w-8xl px-4 md:px-6">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">
              Filosofia de atendimento
            </p>
            <h2 className="mt-3 font-heading text-3xl font-medium leading-tight text-foreground-50 md:text-4xl">
              {philosophy.title}
            </h2>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {philosophy.cards.map((card, i) => (
            <Reveal key={card.title} delay={i * 100}>
              <div className="flex h-full flex-col rounded-lg border border-secondary-300 bg-background-50 p-8 transition-transform duration-300 hover:-translate-y-1">
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-accent-500/15 text-accent-400">
                  <i className={`${card.icon} text-2xl`} />
                </span>
                <h3 className="mt-6 font-heading text-2xl font-semibold text-foreground-50">
                  {card.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-400">{card.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}